import { useState } from "react";

import { roleProviderId } from "@smart/bridge-smokeball-basic";
import { useAsync } from "@smart/itops-hooks-dom";

import {
  GqlMatterLayout,
  GqlMatterType,
  LoadMatterFields,
  MatterField,
} from "../../types";

export const useContactRoleFields = ({
  roleLayouts,
  matterTypes,
  loadMatterFields,
}: {
  roleLayouts: GqlMatterLayout[];
  matterTypes?: GqlMatterType[];
  loadMatterFields: LoadMatterFields;
}) => {
  const [matterFieldsByRole, setMatterFieldsByRole] = useState<
    Record<string, MatterField[]>
  >({});
  const [isLoading, setIsLoading] = useState(false);
  const matterTypeIds = matterTypes?.map((matterType) => matterType.id);

  useAsync(
    async (info) => {
      if (!roleLayouts.length) {
        setMatterFieldsByRole({});
        return;
      }

      setIsLoading(true);
      try {
        const results = await Promise.all(
          roleLayouts.map((layout) =>
            loadMatterFields({
              matterLayoutId: layout.id,
              matterTypeIds,
              providerId: roleProviderId,
            }),
          ),
        );

        if (!info.mounted) return;

        setMatterFieldsByRole(
          roleLayouts.reduce(
            (agg, layout, index) => ({ ...agg, [layout.name]: results[index] }),
            {} as Record<string, MatterField[]>,
          ),
        );
      } finally {
        if (info.mounted) setIsLoading(false);
      }
    },
    [
      roleLayouts.map((layout) => layout.id).join(","),
      matterTypeIds?.join(","),
    ],
  );

  return { matterFieldsByRole, isLoading };
};
